import { LoggingService, LookupService } from 'src/services';
import { DealerSettingDTO } from 'src/services/generated/api.generated.v1';
import { ActionTree, Commit } from 'vuex';
import { StateInterface } from '../index';
import { SettingStateInterface } from './state';


const actions: ActionTree<SettingStateInterface, StateInterface> = {
  clearSettings({ commit }: { commit: Commit }) {
    commit('updateSettingState', null);
  },
  setSettings({ commit, state }: { commit: Commit, state: SettingStateInterface }): Promise<void> {
    const lookupService = new LookupService();

    return new Promise((resolve, reject) => {
      if (state.initialized) {
        resolve();
      } else {
        lookupService.Settings()
          .then((dto: DealerSettingDTO) => {
            commit('updateSettingState', dto);
            resolve();
          })
          .catch(err => {
            LoggingService.LogError(err);
            reject();
          });
      }
    });
  },
};

export default actions;
